import * as Yup from 'yup';
import { SupportTopic } from '@yoweb/types/enums';
import hasFullWidthChars from '@yoweb/utils/intl/hasFullWidthChars';

var form = function form(t, _ref) {
  var localeHasFullWidthChars = _ref.localeHasFullWidthChars;
  return {
    topic: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    },
    givenName: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    },
    familyName: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    },
    email: {
      defaultValue: '',
      validation: Yup.string().trim().test({
        message: t('validation.enter-half-width-characters'),
        test: function test(value) {
          return value && localeHasFullWidthChars ? !hasFullWidthChars(value) : true;
        }
      }).email(t('validation.enter-valid-address')).required(t('validation.required'))
    },
    description: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    }
  };
};

export var getTopicsOptions = function getTopicsOptions(t) {
  return [SupportTopic.EXISTING_MEMBERSHIP, SupportTopic.MEMBERSHIP_WAITLIST, SupportTopic.YO_APP, SupportTopic.BILLING_PURCHASES_ACCOUNT, SupportTopic.PARTNER_AFFILIATE, SupportTopic.PRESS, SupportTopic.URGENT].map(function (option) {
    return {
      value: option,
      label: t("form.topic.topics.".concat(option), {
        ns: 'faq'
      })
    };
  });
};
export default form;